/**
 * Business timezone for the frontend.
 *
 * Mirrors `BUSINESS_TIMEZONE` in `be/utils/businessCalendar.js` — same concept,
 * same value. Keep the two in sync; the backend is the authority.
 *
 * Import this instead of hardcoding 'Asia/Riyadh' in a component.
 *
 * Applies to DISPLAY only. It is not a substitute for asking the server which
 * business day a record belongs to — see
 * docs/03_Technical/TIMEZONE_IMPLEMENTATION_STATUS.md.
 */

// Saudi-only operation. Riyadh is UTC+3 with no daylight saving.
export const BUSINESS_TIMEZONE = 'Asia/Riyadh';
